import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_round-check",
  "use": "icon_round-check-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon_round-check\"><rect width=\"7\" height=\"7\" x=\"2.5\" y=\"2.5\" stroke=\"currentColor\" stroke-opacity=\".5\" rx=\"3.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol